<template>
  <div v-if="renderReady && !model.$disabled">
    <w-label
      :model="model"
      :title="title"
      :show-label="showLabel"
      :description="description"
      :next-number="nextNumber"
      :bold-label="boldLabel"
    >
      <template v-slot:description>
        <slot name="description" />
      </template>
    </w-label>

    <ol class="tabulator">
      <template v-for="(item, index) in model.$items">
        <li :key="'oswiadczenie' + index">
          <w-statement :model="item.$item" />
        </li>
      </template>
    </ol>
  </div>
</template>

<script>
import WStatement from './Statement.vue';
import titleMixin from '../../mixins/titleMixin';
import modelMixin from '../../mixins/modelMixin';

export default {
  name: 'w-statements',
  components: {WStatement},
  mixins: [modelMixin, titleMixin]
};
</script>